import React from "react";
import { CheckCircle2 } from "lucide-react";

export default function FormSuccessMessage({ message, dark = false, onReset }) {
  return (
    <div className={`rounded-md p-6 ${dark ? "bg-br-charcoal text-white border border-br-bronze" : "bg-br-paper border border-br-bronze"}`} data-testid="form-success">
      <div className="flex items-start gap-3">
        <CheckCircle2 className="text-br-bronze" />
        <div>
          <h4 className="font-display text-lg tracking-wider uppercase mb-2">Request Received</h4>
          <p className="text-sm leading-relaxed">{message}</p>
          {onReset && (
            <button className="mt-4 text-xs uppercase tracking-widest font-semibold text-br-bronze hover:underline" onClick={onReset}>
              Submit another request
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
